export default function (app) {
  app.directive("debounce", {
    mounted: (el, binding) => {
      let delay = binding.args;
      if (!delay) {
        delay = 1000;
      }
      let time;
      el.addEventListener("click", () => {
        el.style['pointer-events'] = 'none';
        if (time) {
          clearTimeout(time);
        }
        time = setTimeout(() => {
        el.style['pointer-events'] = '';
        }, delay);
      });
    },
  });  
}
